export default __webpack_public_path__ + "static/media/dsv-ontime-es.018d6b2c.svg";